import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const ConsumerProtection = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Consumer Protection Laws here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Welcome to <span className="kwa">KWA</span>, a distinguished legal practice specializing in <span className="highlight">consumer protection laws</span> in India. Our firm prides itself on its unwavering commitment to safeguarding the rights and interests of consumers against <span className="highlight">unfair</span> and <span className="highlight">deceptive trade</span> practices.</p>
<br />
<p>Under the ambit of Indian laws, consumers are entitled to certain fundamental rights ensuring their protection in commercial transactions. Our team of seasoned attorneys possesses an in-depth understanding of the intricate nuances of consumer protection laws, including but not limited to the <span className="highlight">Consumer Protection Act, 2019</span>, and other relevant statutes.</p>
<br />
<p>At <span className="kwa">KWA</span>, we offer comprehensive legal services tailored to meet the diverse needs of our clients. From providing legal advice and representation in disputes arising from <span className="highlight">defective products</span> to advocating for compensation in cases of <span className="highlight">fraudulent practices</span>, our expertise spans across various aspects of consumer protection laws.</p>
<br />
<p>Our firm is dedicated to upholding the principles of justice and fairness, ensuring that consumers receive just and equitable remedies for any harm or injustice suffered due to the actions of unscrupulous businesses. With a track record of successful litigation and a reputation for excellence in the field, <span className="kwa">KWA </span>stands as a beacon of hope for consumers seeking redressal in the face of <span className="highlight">exploitation</span> and <span className="highlight">misconduct</span>.</p>
<br />
<p>Trust <span className="kwa">KWA </span>to be your ally in the pursuit of justice and accountability under <span className="highlight">Indian consumer protection laws</span>. Contact us today to schedule a consultation with our experienced legal team.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default ConsumerProtection
